import AssessmentCandidatePage from "./AssessmentCandidatePage";

const HackerRankCandidate = () => {
  return <AssessmentCandidatePage provider="hackerrank" />;
};

export default HackerRankCandidate;
